import { useEffect, useState } from "react";
import { useSmoothLoading } from "../../../hooks/useSmoothLoading";
import { getPresignedImage } from "../../../utils/media";

type AttachmentState = {
  documentId: string;
  document: { label: string; fileUrl?: string; fileType?: string };
} | null;

type UseFetchDocumentReturn = {
  isEnabled?: boolean;
};

export const useFetchDocument = (documentId: string | null, options: UseFetchDocumentReturn = {}) => {
  const { isEnabled = true } = options;
  const [attachment, setAttachment] = useState<AttachmentState>(null);
  const { isLoading, startLoading, stopLoading } = useSmoothLoading();

  useEffect(() => {
    if (!isEnabled || !documentId) {
      setAttachment(null);
      return;
    }

    const fetchDocumentDetails = async () => {
      startLoading();
      try {
        const documentDetails = await getPresignedImage([documentId], true, true);
        const docData = documentDetails?.[0]?.documnentData;
        const fileName = docData?._id && docData?.type ? `${docData._id}.${docData.type}` : "Document";

        setAttachment({
          documentId,
          document: { label: fileName, fileUrl: documentDetails[0]?.location, fileType: docData?.type },
        });
      } catch (error) {
        console.error("Failed to fetch document details:", error);
        setAttachment({
          documentId,
          document: { label: "Document", fileUrl: null, fileType: null },
        });
      } finally {
        stopLoading();
      }
    };

    fetchDocumentDetails();
  }, [documentId, isEnabled]);

  const clearAttachment = () => {
    setAttachment(null);
  };

  return {
    attachment,
    isLoading,
    clearAttachment,
  };
};
